import React from "react";
import { useTranslation } from "react-i18next";
import { getLocale, formatDateLong } from "../../../helpers/dates";
import { format } from "date-fns";
import { useSelector } from "react-redux";

const SummaryTransfer = () => {
  const { t } = useTranslation();
  const lng = useSelector((state) => state.app.language);
  const locale = getLocale(lng);
  const reservation = useSelector((state) => state.reservation);
  const transferType = reservation?.reservationTransferRequest?.transferType;

  const origin = { 
    ...(reservation?.reservationTransferRequest?.trips?.[0] ?? {}), 
    fromPickup: reservation?.transferFrom, 
    toPickup: reservation?.transferTo 
  };

  const destination =transferType === 'ROUNDTRIP' ? { 
    ...(reservation?.reservationTransferRequest?.trips?.[1] ?? {}), 
    fromPickup: reservation?.transferTo, 
    toPickup: reservation?.transferFrom
  } : null;

  if(reservation === null) {
    return null;
  }

  return (
    <>
      <div className="mt-1">
        <span className="fw-700 font-tiny">
          {t("transfer.outboundTransfer")}
        </span>
        <div className="row text-tertiary mt-2">
          <div className="col-auto pr-0">{t("transfer.from")}:</div>
          <div className="col ps-0 fw-600 text-right">
            {origin.fromPickup.label}
          </div>
        </div>
        <div className="row text-tertiary mt-2 pt-1">
          <div className="col-auto pr-0">{t("transfer.to")}:</div>
          <div className="col ps-0 fw-600 text-right">{origin.toPickup.label}</div>
        </div>
        <div className="row text-tertiary mt-2 pt-1">
          {origin.fromPickup.pointType === "AIRPORT" ? (
            <>
              <div className="col-auto pr-0">{t("transfer.arrivalFlight")}:</div>
              <div className="col ps-0 text-right">
                <p className="fw-600 m-0">
                  {origin.airline} · #{origin.flightNumber}
                </p>
                <p className="m-0 mt-1">
                  {formatDateLong(origin.transferDate, locale)}
                </p>
                <p className="m-0 mt-1">
                  {format(new Date(origin.transferDate), "h:mm aaa", {
                    locale,
                  })}
                </p>
              </div>
            </>
          ) : (
            <>
              <div className="col-auto text-tertiary pr-0">
                {t("transfer.pickupDateTime")}:
              </div>
              <div className="col ps-0 text-right">
                <p className="m-0 fw-600">
                  {formatDateLong(origin.transferDate, locale)}
                </p>
                <p className="m-0 mt-1">
                  {format(new Date(origin.transferDate), "h:mm aaa", {
                    locale,
                  })}
                </p>
              </div>
            </>
          )}
        </div>
      </div>

      {destination && (
        <div className="mt-4">
          <span className="fw-700 font-tiny">
            {t("transfer.inboundTransfer")}
          </span>
          <div className="row text-tertiary mt-2">
            <div className="col-auto pr-0">{t("transfer.from")}:</div>
            <div className="col ps-0 fw-600 text-right">
              {destination.fromPickup.label}
            </div>
          </div>
          <div className="row text-tertiary mt-2 pt-1">
            <div className="col-auto pr-0">{t("transfer.to")}:</div>
            <div className="col ps-0 fw-600 text-right">
              {destination.toPickup.label}
            </div>
          </div>
          <div className="row text-tertiary mt-2 pt-1">
            {destination.toPickup.pointType === "AIRPORT" ? (
              <>
                <div className="col-auto pr-0">{t("transfer.departureFlight")}:</div>
                <div className="col ps-0 text-right">
                  <p className="fw-600 m-0">
                    {destination.airline} · #{destination.flightNumber}
                  </p>
                  <p className="m-0 mt-1">
                    {formatDateLong(destination.transferDate, locale)}
                  </p>
                  <p className="m-0 mt-1">
                    {format(new Date(destination.transferDate), "h:mm aaa", {
                      locale,
                    })}
                  </p>
                </div>
              </>
            ) : (
              <>
                <div className="col-auto text-tertiary pr-0">
                  {t("transfer.pickupDateTime")}:
                </div>
                <div className="col ps-0 text-right">
                  <p className="m-0 fw-600">
                    {formatDateLong(destination.transferDate, locale)}
                  </p>
                  <p className="m-0 mt-1">
                    {format(new Date(destination.transferDate), "h:mm aaa", {
                      locale,
                    })}
                  </p>
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SummaryTransfer;
